import LegalLayout from '../components/legal/LegalLayout'
import source, { VERSION, EFFECTIVE_DATE } from '../assets/legal/practiceCookies'

// One document, one page, one chunk. See components/legal/LegalLayout.jsx for
// why these are not a single :slug route.

export default function LegalCookies() {
  return (
    <LegalLayout
      slug="cookies"
      title="Cookie Notice"
      version={VERSION}
      date={EFFECTIVE_DATE}
      source={source}
    />
  )
}
